import React from 'react';
import kws from '../images/clients/kws.png';
import geps from '../images/clients/geps.png';
import protergia from '../images/clients/protergia.png';
import dmo from '../images/clients/dmo.png';
import Slider from '../pages/Slider';


const clientImage = {
    height: '10rem',
    width: 'auto',
    mixBlendMode: 'colorBurn'
}

const Clients = () => {
    return (
        <div className="bg-gray-100">
            <section data-aos="fade-up">
                {/* <div className="my-4 py-4"> */}
                <div >
                        <h2 className="text-center text-3xl md:text-4xl lg:text-5xl text-blue-900 uppercase font-bold">Our Clients</h2>
                        <div className='flex justify-center'>
                            <div className='w-24 border-b-4 border-blue-900'></div>
                        </div>
                        <h2 className="mt-4 mx-12 text-center text-xl md:text-2xl lg:text-3xl font-semibold text-blue-900">Some of our clients.</h2>
                    </div>
<Slider/>
<br/>
            </section>
        </div>
    )
}

export default Clients;